export default {
  loaded: false,
  entities: [],
  viewedEntityIds: [],
}
